import React from 'react';
import { EArchiveItem } from './EArchiveListItem';
import styles from './EArchiveListItemGridView.module.scss';
import EArchiveListItemStatusBadge from './EArchiveListItemStatusBadge';
import EArchiveListItemVerificationBadge from './EArchiveListItemVerificationBadge';
import { useAppContext } from '../../../../Services/AppContext';
import UserAvatarImage from '../../../../Components/UserAvatar/UserAvatarImage';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import EArchiveListItemSourceBadge from './EArchiveListItemSourceBadge';

interface Props {
	item: EArchiveItem;
	onClick: () => void;
}

const EArchiveListItemGridView: React.FC<Props> = ({ item, onClick }) => {
	const { isLatam } = useAppContext();
	const { showSelectCheckbox, userIds, onToggleUser } = useSelectUsersContext();

	const isSelected = userIds.includes(item.user.id);

	return (
		<>
			<div className={styles.item} onClick={onClick}>
				{showSelectCheckbox && (
					<div className={styles.checkboxWrapper}>
						<Checkbox
							value={isSelected}
							onChange={() => onToggleUser(item.user.id)}
						/>
					</div>
				)}
				<div className={styles.image}>
					<UserAvatarImage
						userId={item.user.id}
						profileImageUrl={item.user.profileImageUrl}
					/>
				</div>
				<div className={styles.name}>
					{item.user?.profile?.fullName ?? item.user?.email}
				</div>
				{!isLatam && (
					<div className={styles.birthNumber}>
						{item.user?.profile?.formattedBirthNumber}
					</div>
				)}
				<div className={styles.badges}>
					<div>
						<EArchiveListItemVerificationBadge
							csszResult={item.user.vzpResult}
							vzpResult={item.user.csszResult}
						/>
					</div>
					{item.user.workplaceMember?.dateOfDeath && (
						<img
							className={styles.cross}
							src='/dist/icons/cross-sharp-solid.svg'
							alt='cross'
						/>
					)}
				</div>
				<div className={styles.badgeWrapper}>
					{item.user.workplaceMember?.source && (
						<EArchiveListItemSourceBadge
							source={item.user.workplaceMember.source}
						/>
					)}
					<EArchiveListItemStatusBadge
						status={item.status}
						hasMeddi={item.user.hasMeddi}
					/>
				</div>
			</div>
		</>
	);
};

export default EArchiveListItemGridView;
